<template lang="pug">
  div.calculation.regional-tariff-update-first
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="() => {}"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template Расчет Единого тарифа на услугу Регионального оператора на {{fields.yearOrder}} год действия Соглашения
        e-steps(
        :steps="regionalTariffSteps"
        )
      slot
        e-form(:formValidator="formValidator")

          div.body.title-body
            div.col
              div.col-block
                label 1. Индексация величины собственных расходов РО

          div.body.title-body
            div.col
              div.col-block
                label 1.1. Укажите величину расходов РО на сбор и транспортирование ТКО в прошлом периоде

          div.body
            div.col
              div.col-block
                e-form-group(
                name="own_expenses_first"
                inputType="input"
                label="Расходы РО на сбор и транспортирование ТКО в 1-ом году Соглашения"
                :model="fields"
                :required="true"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 1.2. Укажите величину прочих расходов РО в прошлом периоде

          div.body
            div.col
              div.col-block
                e-form-group(
                name="own_expenses_others_prev"
                inputType="input"
                label="Прочие расходы РО в 1-ом году Соглашения"
                :model="fields"
                :required="true"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 1.3. Укажите Индекс потребительских цен

          div.body
            div.col
              div.col-block
                e-form-group(
                name="CPI"
                inputType="input"
                label="Индекс потребительских цен на 2-ой год Соглашения (например - 100,3)"
                :model="fields"
                :required="true"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 1.4. Корректировка расходов на транспортирование отходов
                span(v-if="tableErrors.transportCosts").error {{tableErrors.transportCosts}}
          div.body
            div.col
              e-button-add(@click="addNewRowToTable('transportCosts')")

          div.body
            div.col
              e-table-editable(
              :tableInOnlineMode="null"
              :enableOnAdd="enableOnAdd"
              :attributes="transportCostsAttributes"
              ref="transportCosts"
              :dataUrl="transportCostsDataUrl"
              :postUrl="() => null"
              :patchUrl="() => null"
              :deleteUrl="() => null"
              :tableHeight="'200'"
              :tableHeightRight="'200'"
              :fewRowsCount="2"
              :defaultColumnWidth="80"
              )

          div.body.title-body
            div.col
              div.col-block
                label 1.5. Укажите коэффициент снижения расходов на транспортирование отходов после сортировки или перегрузки

          div.body
            div.col
              div.col-block
                e-form-group(
                name="coefficient_of_cost_reduction"
                inputType="input"
                label="Коэффициент снижения расходов (по умолчанию - 0,4)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="true"
                )

          hr

          div.body.title-body
            div.col
              div.col-block
                label 2. Корректировка необходимой валовой выручки регионального оператора

          div.body.title-body
            div.col
              div.col-block
                label 2.1. Укажите величину изменения НВВ РО при пересмотре тарифов операторов по обращению с ТКО

          div.body
            div.col
              div.col-block
                e-form-group(
                name="change_of_cost_reduction_by_prev_period"
                inputType="input"
                label="Изменение Расходов РО на обезвреживание и захоронение по итогам прошлого периода"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 2.2. Укажите величину изменения собственных расходов РО в связи с отклонением факт. объема (массы) ТКО от объема (массы), учтенного при установлении тарифов

          div.body
            div.col
              div.col-block
                e-form-group(
                name="change_of_own_expenses_by_prev_period"
                inputType="input"
                label="Изменение собственных расходов РО по итогам прошлого периода"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 2.3. Укажите величину Индекса потребительских цен за прошлый период

          div.body
            div.col
              div.col-block
                e-form-group(
                name="CPI_prev"
                inputType="input"
                label="ИПЦ, учтенный при установлении тарифов"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )

          div.body
            div.col
              div.col-block
                e-form-group(
                name="CPI_fact"
                inputType="input"
                label="ИПЦ, фактический"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )


          div.body.title-body
            div.col
              div.col-block
                label 2.4. Заполните пустые ячейки для корректировки НВВ РО из-за изменения объема (массы) отходов, направленных Региональным оператором на объект оператора по обращению с твердыми коммунальными отходами в прошлом периоде
                span(v-if="tableErrors.grossRevenue").error {{tableErrors.grossRevenue}}
          div.body
            div.col
              e-button-add(@click="addNewRowToTable('grossRevenue')")

          div.body
            div.col
              e-table-editable(
              :tableInOnlineMode="null"
              :enableOnAdd="enableOnAdd"
              :attributes="grossRevenueAttributes"
              ref="grossRevenue"
              :dataUrl="grossRevenueDataUrl"
              :postUrl="() => null"
              :patchUrl="() => null"
              :deleteUrl="() => null"
              :tableHeight="'200'"
              :tableHeightRight="'200'"
              :fewRowsCount="2"
              )

          div.body.title-body
            div.col
              div.col-block
                label 2.5. Укажите величину корректировки необходимой валовой выручки регионального оператора в связи с изменением законодательства, не учтенным при установлении тарифов
          div.body
            div.col
              div.col-block
                e-form-group(
                name="change_of_correction_due_law"
                inputType="input"
                label="Величина корректировки"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 2.6. Укажите величину корректировки необходимой валовой выручки регионального оператора в связи с изменением территориальной схемы, не учтенным при установлении тарифов
          div.body
            div.col
              div.col-block
                e-form-group(
                name="change_of_correction_due_scheme"
                inputType="input"
                label="Величина корректировки"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 2.7. Укажите величину корректировки необходимой валовой выручки регионального оператора в связи с возмещением расходов по нерегулируемым видам деятельности
          div.body
            div.col
              div.col-block
                e-form-group(
                name="change_of_correction_irregular_transport"
                inputType="input"
                label="Величина корректировки"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )


          hr

          div.body.title-body
            div.col
              div.col-block
                label 3. Расчет объема (массы) отходов, сбор и транспортирование которых будет осуществлять РО

          div.body.title-body
            div.col
              div.col-block
                label 3.1. Укажите количество отходов, сбор и транспортирование которых будет осуществлять региональный оператор

          div.body
            div.col
              div.col-block
                e-form-group(
                name="v_waste"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countVMRequired"
                )
            div.col
              div.col-block
                e-form-group(
                name="m_waste"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countVMRequired"
                )
            div.col
              div.col-block

          div.body.title-body
            div.col
              div.col-block
                label
                 u либо
                 br
                 | введите данные о фактическом объеме (массе) отходов, сбор и транспортирование которых осуществлял региональный оператор в последние 4 года

          div.body.title-body
            div.col
              div.col-block
                label i год
                e-form-group(
                name="v_waste_i"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label i-1 год
                e-form-group(
                name="v_waste_i_1"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label i-2 год
                e-form-group(
                name="v_waste_i_2"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label i-3 год
                e-form-group(
                name="v_waste_i_3"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
            div.col
              div.col-block
                label &nbsp;
                e-form-group(
                name="m_waste_i"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label &nbsp;
                e-form-group(
                name="m_waste_i_1"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label &nbsp;
                e-form-group(
                name="m_waste_i_2"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
                label &nbsp;
                e-form-group(
                name="m_waste_i_3"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="countFourYearsRequired"
                )
            div.col
              div.col-block

          div.body.title-body
            div.col
              div.col-block
                label 3.2. Укажите количество отходов, направляемое Региональным оператором на объекты других операторов и обновленные тарифы
                span(v-if="tableErrors.tariffsConsiderSent").error {{tableErrors.tariffsConsiderSent}}
          div.body
            div.col
              e-button-add(@click="addNewRowToTable('tariffsConsiderSent')")

          div.body
            div.col
              e-table-editable(
              :tableInOnlineMode="null"
              :enableOnAdd="enableOnAdd"
              :attributes="tariffsConsiderSentAttributes"
              ref="tariffsConsiderSent"
              :dataUrl="tariffsConsiderSentDataUrl"
              :postUrl="() => null"
              :patchUrl="() => null"
              :deleteUrl="() => null"
              :tableHeight="'200'"
              :tableHeightRight="'200'"
              :fewRowsCount="2"
              :defaultColumnWidth="80"
              :afterValidate="afterValidateTariffsConsiderSent"
              )

</template>

<script>
  import {mongoApi} from '../../api/api-endpoints.js'
  import {CalculationRegionalTariffs} from '../../config/mongo'
  import regionalTariffNextForm from './mixins/regional-tariff-next-form'

  export default {
    mixins: [regionalTariffNextForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
        }
      }
    },
    methods: {
      onSuccess (response, afterSaveResponse) {
        this.onSuccessSaveCalculation(response, afterSaveResponse)
      },
      getUpdateOrCreateUrl () {
        return mongoApi.updateCollectionItem(CalculationRegionalTariffs, this.$route.params.id)
      },
      getItemEndpoint (route) {
        return mongoApi.getCollectionItem(CalculationRegionalTariffs, route.params.id)
      },
      getDeleteUrl (id) {
        return null
      },
      getItemsEndpoint (route, fromRoute) {
        return mongoApi.getCollectionItems(CalculationRegionalTariffs, {
          query: {
            'filter[operator_id]': route.query['filter[operator_id]']
          }
        })
      }
    }
  }
</script>
